import React from 'react';
import { Controller } from 'react-hook-form';
import { Datepicker } from "../datepicker/Datepicker.js";
import { isValueValid } from "../formRenderer/index.js";

// ToDo: Get rid of internal proxy input prop type -> Breaking change for next major version
import { jsx as _jsx } from "react/jsx-runtime";
export function FormDatepicker({
  control,
  name,
  rules,
  defaultValue,
  datepickerProps,
  showCheckmark
}) {
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    rules: rules,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        onBlur,
        value,
        name,
        ref
      },
      fieldState: {
        error
      }
    }) =>
    /*#__PURE__*/
    /* @ts-expect-error onBlur and onBlurFn can be inserted in datePickerProps */
    _jsx(Datepicker, {
      ...datepickerProps,
      name,
      value,
      inputRef: ref,
      error: error?.message === 'true' ? true : error?.message,
      onSelection: (date, formattedDate) => {
        onChange(formattedDate);
        datepickerProps.onSelection?.(date, formattedDate);
      },
      onBlur: e => {
        onBlur();
        datepickerProps.onBlur?.(e);
      },
      onChange: e => {
        onChange(e);
        datepickerProps.onChange?.(e);
      },
      valid: showCheckmark && isValueValid(error, value)
    })
  });
}